module.exports = __webpack_public_path__ + "static/media/UST-BUSD.940c8fc7.svg";